import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, matchPath } from 'react-router-dom'
import { IMainMenu, MainMenu } from 'constants/menu'
import { UserContext } from 'context/UserContext'
import { UserRoleEnum } from 'generated/api'

interface IProps {
  closeSidebar: () => void
}

const SidebarMenu = (props: IProps) => {
  const [user] = useContext(UserContext)

  const [mainMenu, setMainMenu] = useState<IMainMenu[]>([])
  const { pathname } = useLocation()

  /**
   * @description
   * Will set selected menu submenuVisibility to true
   * when menu clicked
   *
   * @param index index of element
   */
  const toggleSubmenu = (index: number): void => {
    setMainMenu([...MainMenu])
    const menus = [...mainMenu]
    const menu = { ...menus[index], submenuVisibility: !menus[index].submenuVisibility }
    menus[index] = menu
    setMainMenu(menus)
  }

  /**
   * @description
   * will check current pathname includes selected menu path name
   *
   * @param path : path of route
   * @returns boolean
   */
  const matchRoutePath = (path: string): boolean => {
    const matched = matchPath({ path: path + '/*' }, pathname)
    return matched ? true : false
  }

  /**
   * @description
   * automatically set submenuVisibility to true when any
   * menu path that match current route path
   */
  useEffect(() => {
    const menus = MainMenu.filter((menu) =>
      menu.roles.includes(user.userInfo?.role ? user.userInfo?.role : UserRoleEnum.Operation)
    )
    const activeMenuIdx = menus.findIndex((item) => matchPath({ path: item.to + '/*' }, pathname))
    const menu = { ...menus[activeMenuIdx], submenuVisibility: true }
    menus[activeMenuIdx] = menu
    setMainMenu(menus)
  }, [])

  return (
    <ul className="sidebar__menu">
      {mainMenu.map((menu, index) => (
        <li
          key={menu.name}
          className={
            matchRoutePath(menu.to)
              ? 'sidebar__menu__item sidebar__menu__item--active'
              : 'sidebar__menu__item'
          }
        >
          {/* Showing link only when submenu exist */}
          {menu.submenus.length < 1 ? (
            <Link
              onClick={props.closeSidebar}
              data-testid={'sidebar-menu-link-' + menu.slug}
              to={menu.to}
            >
              <span>{menu.icon}</span>
              <span className="font-medium">{menu.name}</span>
            </Link>
          ) : (
            <div
              data-testid={'sidebar-menu-toggler-' + menu.slug}
              onClick={() => toggleSubmenu(index)}
            >
              <span>{menu.icon}</span>
              <span className="font-medium">{menu.name}</span>
            </div>
          )}

          {/* Submenus only be rendered when exists*/}
          {/* Submenu will automaticaly opened when submenuVisibility is true or the path is match */}
          {menu.submenus.length > 0 && menu.submenuVisibility && (
            <ul>
              {menu.submenus.map((submenu) => (
                <li
                  data-testid={'sidebar-submenu-toggler-' + submenu.slug}
                  className={
                    matchPath({ path: submenu.to }, pathname)
                      ? 'sidebar__menu__item sidebar__menu__item--active'
                      : 'sidebar__menu__item'
                  }
                  key={submenu.name}
                >
                  <Link
                    onClick={props.closeSidebar}
                    data-testid={'sidebar-submenu-link-' + submenu.slug}
                    to={submenu.to}
                  >
                    <span>{submenu.icon}</span>
                    <span>
                      {submenu.name} {menu.submenuVisibility}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  )
}
export default SidebarMenu
